import * as React from 'react';

import { NotAvailablePopup } from '../../components/NotAvailablePopup';
import { useCall } from '../../hooks/useCall';
import { useChatContext, useNotAvailablePopupContext } from '../../context';
import { useOfferContext } from '../OfferContext';
import { IUserAuthenticated } from '../../types';

export const NotAvailablePopupContainer: React.FC = () => {
  const { offerWithPopup, closeNotAvailablePopup } = useNotAvailablePopupContext();
  const { openChat } = useChatContext();
  const { id, author: { agentAvailability, isChatsEnabled } = {}, user } = useOfferContext();
  const authenticatedUser = user as IUserAuthenticated;

  const phone = React.useMemo(() => {
    const { phones } = authenticatedUser;

    return phones?.[0].phone ?? '';
  }, [authenticatedUser]);

  const { produceCall } = useCall();

  const notAvailablePopupProps = React.useMemo(() => {
    const title = agentAvailability?.title;
    const message = agentAvailability?.message;

    if (offerWithPopup !== id || !title || !message) {
      return null;
    }

    return {
      onWriteMessage: () => {
        closeNotAvailablePopup();

        openChat(`Здравствуйте, пожалуйста свяжитесь со мной ${phone}`);
      },
      onCallAnyway: () => {
        closeNotAvailablePopup();

        produceCall(phone, true);
      },
      onClose: () => {
        closeNotAvailablePopup();
      },
      title,
      message,
      isChatEnabled: !!isChatsEnabled,
    };
  }, [agentAvailability, closeNotAvailablePopup, id, isChatsEnabled, offerWithPopup, openChat, phone, produceCall]);

  if (!notAvailablePopupProps) {
    return null;
  }

  return <NotAvailablePopup {...notAvailablePopupProps} />;
};
